import { render, staticRenderFns } from "./TierPicker.vue?vue&type=template&id=31e18b6b"
import script from "./TierPicker.vue?vue&type=script&lang=js"
export * from "./TierPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports